import { render, staticRenderFns } from "./SimilarQuestion.vue?vue&type=template&id=99fcdd4c&scoped=true&"
import script from "./SimilarQuestion.vue?vue&type=script&lang=js&"
export * from "./SimilarQuestion.vue?vue&type=script&lang=js&"
import style0 from "./SimilarQuestion.vue?vue&type=style&index=0&id=99fcdd4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99fcdd4c",
  null
  
)

export default component.exports